import React, { Component } from 'react';

import {Grid, Row, Col} from 'react-bootstrap';

import HorizontalBar from '../components/HorizontalBar';
import DataTable from '../components/DataTable';
import {Radar} from 'react-chartjs-2';

import { normalise } from '../utils/data'

import { OverlayTrigger, Button, Tooltip } from 'react-bootstrap'

import '../css/dependencies.css';

class Report extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            compliance: props.compliance,
            complianceBlockers: props.complianceBlockers,
            complianceWarnings: props.complianceWarnings
        };
        this.renderPie = this.renderPie.bind(this);
    }

    componentDidMount() {
        // Need to filter out assets that don't have "complexityScore"
        // i.e. filter out non-job assets
        let data = [];

        for (let assetName in this.props.data) {
            let asset = this.props.data[assetName];

            if (!("complexityScore" in asset)) {
                asset.complexityScore = {
                    "Cyclomatic": "n/a",
                    "Stage Type": "n/a",
                    "Transformer LOC": "n/a",
                    "total": "n/a"
                };
            }

            data.push(asset);
        }

        this.setState({
            data: data,
            selectedItem: data[0].asset
        });
    }

    componentDidUpdate(prevProps) {
        //this.props.data;
        //prevProps.data;
    }

    renderPie(job){
        let properties = Object.keys(job.complexityScore).filter(prop => prop !== "total");

        let maxScale = Math.max.apply(null, properties.map((prop) => {
            return Math.max.apply(null, this.state.data.map(j => !isNaN(j.complexityScore[prop]) ? normalise(j.complexityScore[prop], prop) : 0));
        }))

        let data ={
            labels: properties,
            datasets: [
                {
                    label: job.asset,
                    data: properties.map(property => normalise(job.complexityScore[property], property)),
                    backgroundColor: 'rgba(179,181,198,0)',
                    borderColor: "#4EC9B4",
                    pointBackgroundColor: "#4EC9B4",
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: "#4EC9B4",

                },
                {
                    label: "Average",
                    data: properties.map(property => {
                        let value = this.state.data.reduce((total, item, index, array) => {
                            if (isNaN(total)) total = 0;
                            total += normalise(item.complexityScore[property], property);

                            if ( index === array.length-1) {
                                return total/array.length;
                            } else {
                                return total;
                            }
                        })

                        return value;
                    }),
                    backgroundColor: 'rgba(179,181,198,0)',
                    borderColor: '#666666',
                    pointBackgroundColor: '#666666',
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: '#666666',
                }

            ]

        }

        return (
            <Radar data={data} options={{
                scale: {
                    ticks: {
                        min : 0,
                        max : maxScale
                    }
                }
            }}/>
        )
    }

	onPressDownload(zipName) {
        let tableData = this.state.data.map(asset => {
            let failedComplianceRules = 0;
            let failedComplianceBlockers = 0;
            let failedComplianceWarnings = 0;


			if (typeof asset.compliance === "undefined") {
	            for (let c of asset.complianceBlocker || []) {
	                if (c.result === "FAILURE") failedComplianceBlockers++;
	            }

	            for (let c of asset.complianceWarning || []) {
	                if (c.result === "FAILURE") failedComplianceWarnings++;
	            }
	
	            return [
	                asset.asset,
	                asset.assetType,
	                asset.complexityScore.total,
	                asset.complexityScore["Transformer LOC"],
	                asset.complexityScore["Stage Type"],
	                asset.complexityScore["Cyclomatic"],
	                failedComplianceBlockers,
					failedComplianceWarnings,
	                asset.archive,
	                asset.engine,
	                asset.project,
	            ];
			} else {
	            for (let c of asset.compliance) {
	                if (c.result === "FAILURE") failedComplianceRules++;
	            }
	
	            return [
	                asset.asset,
	                asset.assetType,
	                asset.complexityScore.total,
	                asset.complexityScore["Transformer LOC"],
	                asset.complexityScore["Stage Type"],
	                asset.complexityScore["Cyclomatic"],
	                failedComplianceRules,
	                asset.archive,
	                asset.engine,
	                asset.project,
	            ];
			}
        });
		var complianceCols = (typeof tableData.failedComplianceRules === "undefined") ? "Compliance Blockers, Compliance Warnings, " : "Compliance Issues, ";
		var csv = "Asset Name, Asset Type, Complexity Rating, Transformer LOC, Stage Type, Cyclomatic, " + 
				  complianceCols + 
				  "Archive, Engine, Project\n" + 
				  tableData.map(function(d){
        	return d.join();
    	}).join('\n');

		var fileName = zipName+'_data.csv';
       	var blob = new Blob([ csv ], {
            type : "application/csv;charset=utf-8;"
        });

		if (window.navigator.msSaveOrOpenBlob) {
		     window.navigator.msSaveBlob(blob, fileName);
		} else {
            var link = document.createElement("a");
            var csvUrl = URL.createObjectURL(blob);
            link.href = csvUrl;
            link.style = "visibility:hidden";
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
		}
	}
	
    render() {
        if(!this.state.data) return (<div></div>);

        return (
            <Grid>
                <Row className="show-grid">
                    <Col xs={6} md={6}>
                        <HorizontalBar
                            data = {
                                this.state.data.filter(asset => asset.complexityScore.total !== "n/a").map(job => {
                                    return {
                                        label : job.asset,
                                        value : job.complexityScore.total
                                    }
                                })
                            }
                            selectedValue = {
                                this.state.data.find(item => item.asset === this.state.selectedItem).complexityScore.total
                            }
                        />
                    </Col>
                    <Col xs={6} md={6}>
                        {this.renderPie(this.state.data.find(item => item.asset === this.state.selectedItem))}
                    </Col>
                </Row>
				<Row className="show-grid" >
				<Col xs={11} md={11}/>
				<Col xs={1} md={1}>			
                    <Button className="btn-download" onClick={() => { this.onPressDownload(this.props.fileName) }}>
                        <OverlayTrigger placement="left" overlay={<Tooltip id="edit">Download Table</Tooltip>}>
                            <i className="fa fa-download"></i>
                        </OverlayTrigger>
                    </Button>
 				</Col>
				</Row>
                <Row className="show-grid" style={{"marginTop":"-20px"}}>
                    <br/>
                    <Col xs={12} md={12}>
                      <DataTable
                          jobData={this.state.data}
                          complianceNotAvailable={this.props.complianceNotAvailable}
                          selected={this.state.selectedItem}
                          newSelection = {
                              (Item) => {
                                  this.setState({
                                      selectedItem : Item
                                  })
                              }
                          }
                      />
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default Report;
